
import { SubscriptionCompleteCongratulations } from './components/congratulations';

import styles from './layout.module.scss';

export const SubscriptionCompletePageLayout = () => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.container}>
				<SubscriptionCompleteCongratulations />
			</div>
		</div>
	);
}